// extracted by mini-css-extract-plugin
export const container = "MenuItem-module--container--ImzX-";
export const button = "MenuItem-module--button--vctxK";
export const header = "MenuItem-module--header--2E9Te";
export const is_active = "MenuItem-module--is_active--18CrA";
export const is_root = "MenuItem-module--is_root--2DHhP";
export const sibling_is_active = "MenuItem-module--sibling_is_active--3jVKy";
export const link = "MenuItem-module--link--1DeQP";